import {
  IconDefinition,
  faCloudBolt,
  faCloudBoltMoon,
  faCloudBoltSun,
  faCloudMoonRain,
  faCloudRain,
  faCloudShowers,
  faCloudSleet,
  faCloudSnow,
  faCloudSunRain,
  faMoon,
  faMoonCloud,
  faSun,
  faSunCloud,
} from '@fortawesome/pro-light-svg-icons';

export type WeathercodeMapping = {
  code: number;
  icon: {
    day: IconDefinition;
    night: IconDefinition;
  };
};

export const weathercodeMappings: WeathercodeMapping[] = [
  {
    code: 1,
    icon: {
      day: faSun,
      night: faMoon,
    },
  },
  {
    code: 2,
    icon: {
      day: faSunCloud,
      night: faMoonCloud,
    },
  },
  {
    code: 3,
    icon: {
      day: faSunCloud,
      night: faMoonCloud,
    },
  },
  {
    code: 4,
    icon: {
      day: faCloudSunRain,
      night: faCloudMoonRain,
    },
  },
  {
    code: 5,
    icon: {
      day: faCloudSunRain,
      night: faCloudMoonRain,
    },
  },
  {
    code: 6,
    icon: {
      day: faCloudShowers,
      night: faCloudShowers,
    },
  },
  {
    code: 7,
    icon: {
      day: faCloudBoltSun,
      night: faCloudBoltMoon,
    },
  },
  {
    code: 8,
    icon: {
      day: faCloudSunRain,
      night: faCloudMoonRain,
    },
  },
  {
    code: 9,
    icon: {
      day: faCloudRain,
      night: faCloudRain,
    },
  },
  {
    code: 10,
    icon: {
      day: faCloudRain,
      night: faCloudRain,
    },
  },
  {
    code: 11,
    icon: {
      day: faCloudBolt,
      night: faCloudBolt,
    },
  },
  {
    code: 12,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 13,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 14,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 15,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 16,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 17,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 18,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 19,
    icon: {
      day: faCloudSleet,
      night: faCloudSleet,
    },
  },
  {
    code: 20,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 21,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 22,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 23,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 24,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 25,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 26,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 27,
    icon: {
      day: faCloudSnow,
      night: faCloudSnow,
    },
  },
  {
    code: 28,
    icon: {
      day: faSunCloud,
      night: faMoonCloud,
    },
  },
];
